import { useQuery } from "@tanstack/react-query";
import { getBlogCategoryById } from "../../api/apiBlogCategories";

/**
 * Hook لجلب تصنيف واحد
 * @param {number|string} id - Blog Category ID
 */
export function useGetBlogCategory(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["blog-category", id],
        queryFn: () => getBlogCategoryById(id),
        enabled: !!id,
        retry: false,
    });

    const category = data?.data || null;

    return { isLoading, error, category, refetch };
}
